<template>
  <a :href="href" v-if="isLink" class="cardinfo__link">
    <div :class="`${isBorderRadiusRounded ? 'cardinfo cardinfo--rounded' : 'cardinfo'
      }`">
      <div class="cardinfo__image" :style="`background-image: url(${bgImage})`"></div>
      <div class="cardinfo__wrapper">
        <div class="cardinfo__header">
          <h2 :style="`font-size: ${fontSizeTitle}px; color: ${titleColor}`" class="cardinfo__title">
            {{ limitCharacters(title, 70) }}
          </h2>
          <h3 v-if="subtitle" class="cardinfo__subtitle"
            :style="`font-size: ${fontSizeSubtitle}px; color: ${subtitleColor}`">
            {{ subtitle }}
          </h3>
        </div>
      </div>
    </div>
  </a>

  <div :class="`${isBorderRadiusRounded ? 'cardinfo cardinfo--rounded' : 'cardinfo'
    }`" v-else>
    <div class="cardinfo__image" :style="`background-image: url(${bgImage})`"></div>
    <div class="cardinfo__wrapper">
      <div class="cardinfo__header">
        <h2 :style="`font-size: ${fontSizeTitle}px; color: ${titleColor}`" class="cardinfo__title">
          {{ limitCharacters(title, 70) }}
        </h2>
        <h3 v-if="subtitle" class="cardinfo__subtitle"
          :style="`font-size: ${fontSizeSubtitle}px; color: ${subtitleColor}`">
          {{ subtitle }}
        </h3>
      </div>
      <c-button :radius="50" :bg-color="buttonBackgroundColor" :class="{ 'cardinfo-button-outline': isButtonOutline }"
        :border-color="buttonBorderColor" :href="href">
        <c-text size="md" weight="bolder" :color="buttonTextColor" class="cardinfo__buttonText">
          {{ limitCharacters(buttonText, 30) }}
        </c-text>
      </c-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NtCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    fontSizeTitle: {
      type: String,
      default: '',
    },
    titleColor: {
      type: String,
      default: '',
    },
    subtitleColor: {
      type: String,
      default: '',
    },
    fontSizeSubtitle: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    bgImage: {
      type: String,
      default: '',
    },
    isBorderRadiusRounded: {
      type: Boolean,
      default: false,
    },
    isButtonOutline: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonTextColor: {
      type: String,
      default: '#9ddda9',
    },
    buttonBackgroundColor: {
      type: String,
      default: '#9ddda9',
    },
    buttonBorderColor: {
      type: String,
      default: '#9ddda9',
      required: false,
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      default: '',
    }
  },
  data() {
    return {}
  },
  methods: {
    limitCharacters(text, limit) {
      return text.length > limit ? `${text.substring(0, limit)}...` : text
    },
  },
}
</script>

<style scoped lang="scss">
.cardinfo {
  position: relative;
  width: 100%;
  height: 500px;
  padding: 10px 16px;
  overflow: hidden;

  &:hover & {
    &__image {
      transform: scale(1.08);
    }
  }


  &__image {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    transition: all 0.8s;

    &::before {
      content: "";
      z-index: 1;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0.7;
    }
  }

  &__link {
    display: flex;
    width: 100%;
    color: inherit;
    text-decoration: none;
    position: relative;
    overflow: hidden;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    position: relative;
  }

  &__header {
    text-align: center;
  }

  &__subtitle,
  &__title {
    font-weight: 700;
    line-height: 1em;
    margin-bottom: 20px;
  }

  &--rounded {
    border-radius: 8px;
  }

  &-button-outline {
    background-color: transparent !important;
    border: 2px solid #9ddda9;
  }

  &__buttonText {
    color: #9ddda9;
  }
}
</style>
